import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { observer } from 'mobx-react'
import { useStore } from '../../Models/RootStore'
import { Colors } from '../../Utils/theme'
import { UINotification } from '../../Components'
import Logo from '../../Assets/Images/app_logo.png'
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex'
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  leftColumn: {
    boxSizing: 'border-box',
    flex: 1,
    padding: '2rem',
    backgroundColor: Colors.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

  },
  rightColumn: {
    minHeight: '100vh',
    boxSizing: 'border-box',
    overflow: 'hidden',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Colors.sidebarBackgroundColor,
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  logo: {
    userSelect: 'none',
    width: 300,
    height: 'auto'
  }
}))

function AuthLayout(props) {
  const classes = useStyles()

  const { appStore } = useStore()
  const { notification, clearNotification } = appStore

  return (
    <div className={classes.root}>
      <main className={classes.content}>
        <div className={classes.leftColumn}>
          {props.children}
        </div>
        <div className={classes.rightColumn}>
          <img src={Logo} className={classes.logo} alt='logo' />
        </div>
      </main>
      <UINotification notification={notification} clearNotification={clearNotification} />
    </div>
  )
}

export default observer(AuthLayout)
